import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=2fb5d211"
import script from "./MonitorList.vue?vue&type=script&lang=js"
export * from "./MonitorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports